export default __webpack_public_path__ + "static/media/ico_edit.d7b3ffde.svg";